import { unitDefault, unitTypes } from "@/settings/unitTypes";
export const Reactor = {
  id: "80",
  name: "Reactor",
  mainClass: "Estático",
  subtype: "Catalítico",
  variables: [],
  operationalValues: [
    {
      value: 0,
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "reactorOperationalTemperature"
    },
    {
      value: 0,
      type: unitTypes.pressure,
      unit: unitDefault.pressure.metric,
      code: "reactorOperationalPressure"
    },
    {
      value: 0,
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "reactorDesignTemperature"
    },
    {
      value: 0,
      type: unitTypes.pressure,
      unit: unitDefault.pressure.metric,
      code: "reactorDesignPressure"
    },
    {
      value: 0,
      type: "unique",
      unit: "months",
      code: "reactorCatalystLifetime"
    }
  ]
};
